document.addEventListener('DOMContentLoaded', function () {
  const volumeInput = document.getElementById('volume');
  const volumeToggle = document.getElementById('volumeToggle');
  const currentAlkInput = document.getElementById('currentAlk');
  const desiredAlkInput = document.getElementById('desiredAlk');
  const productSelect = document.getElementById('product');
  const resultDiv = document.getElementById('result');
  const calculateButton = document.getElementById('calculateButton');
  const currentAlkToggle = document.getElementById('currentAlkToggle');
  const desiredAlkToggle = document.getElementById('desiredAlkToggle');

  if (
    !volumeInput ||
    !volumeToggle ||
    !currentAlkInput ||
    !desiredAlkInput ||
    !productSelect ||
    !resultDiv ||
    !calculateButton ||
    !currentAlkToggle ||
    !desiredAlkToggle
  ) {
    console.error('Alkalinity calculator: required elements not found.');
    return;
  }

  function convertToDkh(value, unit) {
    if (unit === 'PPM') return value / 17.857;
    return value;
  }

  function getCurrentAlkUnit() {
    return currentAlkToggle.checked ? 'PPM' : 'dKH';
  }

  function getDesiredAlkUnit() {
    return desiredAlkToggle.checked ? 'PPM' : 'dKH';
  }

  function showResult(html) {
    resultDiv.innerHTML = html;
    resultDiv.classList.add('show');
  }

  function calculateDose() {
    const volume = parseFloat(volumeInput.value);
    const isLiters = volumeToggle.checked;

    let currentAlk = parseFloat(currentAlkInput.value);
    let desiredAlk = parseFloat(desiredAlkInput.value);

    const alkUnit = getCurrentAlkUnit();
    const desiredAlkUnit = getDesiredAlkUnit();
    const k = parseFloat(productSelect.value);

    if (isNaN(volume) || volume <= 0) {
      showResult('Please enter a valid aquarium volume greater than 0.');
      return;
    }

    if (isNaN(currentAlk)) {
      showResult('Please enter your current alkalinity.');
      return;
    }

    if (isNaN(desiredAlk)) {
      showResult('Please enter your desired alkalinity.');
      return;
    }

    currentAlk = convertToDkh(currentAlk, alkUnit);
    desiredAlk = convertToDkh(desiredAlk, desiredAlkUnit);

    if (currentAlk < 0 || currentAlk > 15) {
      showResult('Current alkalinity level must be between 0 and 15 dKH.');
      return;
    }

    if (desiredAlk < 0 || desiredAlk > 15) {
      showResult('Desired alkalinity level must be between 0 and 15 dKH.');
      return;
    }

    if (desiredAlk <= currentAlk) {
      showResult('Desired alkalinity level must be higher than current level.');
      return;
    }

    const volumeLiters = isLiters ? volume : volume * 3.78541;
    const alkIncrease = desiredAlk - currentAlk;
    const totalDosageMl = (alkIncrease * volumeLiters) / k;
    const flOz = totalDosageMl / 29.5735;
    const tsp = totalDosageMl / 5;

    let resultHtml =
      '<div class="result-main">Total required dose: <strong>' + totalDosageMl.toFixed(2) + ' mL</strong></div>' +
      '<div class="result-sub">' + flOz.toFixed(2) + ' fl oz or ' + tsp.toFixed(2) + ' tsp for the entire tank</div>';

    if (alkIncrease > 2) {
      resultHtml +=
        '<div class="result-split">' +
        '<strong>Suggestion:</strong> For safety, split this dose over multiple days:' +
        '<ul>' +
        '<li>2 days: ' + (totalDosageMl / 2).toFixed(2) + ' mL per day</li>' +
        '<li>3 days: ' + (totalDosageMl / 3).toFixed(2) + ' mL per day</li>' +
        '<li>4 days: ' + (totalDosageMl / 4).toFixed(2) + ' mL per day</li>' +
        '</ul>' +
        '</div>';
    }

    showResult(resultHtml);
  }

  calculateButton.addEventListener('click', calculateDose);
});